<template>
  <div class="row">
    <div class="col-12">
      <div class="page_title">
        說明會場次填選
      </div>
    </div>
    <div class="col-12 mb-5">
      <recruitment-orientation-introduce :orientation-info="currentOrientationInfoGetter" />
    </div>
    <div class="col-12 mb-2">
      <recruitment-orientation-time-slots
        :orientations="currentSlots"
        @submit="addSlot"
      />
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-lg-3 offset-lg-9 col-md-5 offset-md-7">
          <button-wrapper
            color="pink"
            @click="batchDeleteSlots"
          >
            刪除已勾選項目
            <font-awesome-icon :icon="['far', 'trash-alt']" />
          </button-wrapper>
        </div>
      </div>
    </div>
    <div class="col-12 mb-5">
      <table-wrapper>
        <table-row>
          <table-heading :cols="1" />
          <table-heading :cols="3">
            日期
          </table-heading>
          <table-heading :cols="3">
            時間
          </table-heading>
          <table-heading :cols="2">
            場次數量
          </table-heading>
          <table-heading :cols="3">
            金額
          </table-heading>
        </table-row>
        <table-row
          v-for="slot in tempSlots"
          :key="slot.orientation_time_slot_id"
        >
          <table-data :cols="1">
            <div class="form-check">
              <check-input
                v-model="batchDelete"
                label=""
                type="checkbox"
                :value="slot.orientation_time_slot_id"
                name="batch-delete-slots"
              />
            </div>
          </table-data>
          <table-data :cols="3">
            {{ slot.orientation_date }}
          </table-data>
          <table-data :cols="3">
            {{ slot.duration }}
          </table-data>
          <table-data :cols="2">
            1
          </table-data>
          <table-data :cols="3">
            {{ currentOrientationInfoGetter.orientation_charge }}
          </table-data>
        </table-row>
      </table-wrapper>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import ButtonWrapper from '~components/common/buttons'
import CheckInput from '~components/common/form/input/Check'
import RecruitmentOrientationTimeSlots from '../common/RecruitmentOrientationTimeSlots'
import RecruitmentOrientationIntroduce from '../common/RecruitmentOrientationIntroduce'

export default {
  name: 'EnterpriseEditRecruitmentOrientation',
  components: {
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    ButtonWrapper,
    CheckInput,
    RecruitmentOrientationTimeSlots,
    RecruitmentOrientationIntroduce
  },
  data () {
    return {
      tempSlots: [],
      batchDelete: [],
      currentSlots: []
    }
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'currentOrientationInfoGetter',
      'currentOrientationDetailsGetter'
    ]),
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseGetter'
    ])
  },
  watch: {
    tempSlots (value) {
      this.$emit('slots:changed', {
        orientation_slots: value,
        orientation_price: this.currentOrientationInfoGetter.orientation_charge,
        orientation_charge_total: this.currentOrientationInfoGetter.orientation_charge * value.length
      })
    },
    currentOrientationDetailsGetter (value) {
      this.currentSlots = value
      this.setTempSlots(value)
      value.forEach((date, index) => {
        this.removeDoubleBookedTempSlots(date.orientation_time_slots, index)
      })
    }
  },
  async created () {
    if (Object.keys(this.currentEnterpriseGetter).length < 1) {
      await this.getEnterpriseByToken()
    }
	
	try {
		if (Object.keys(this.currentOrientationInfoGetter).length < 1) {
		  await this.getRecruitmentDetailsById(this.$route.params.id)
		}
		
		this.getOrientationsDetailsById(this.$route.params.id)
	} catch (err) {
	  this.$router.push('/campus-recruiting');
	}
  },
  methods: {
    ...mapActions('pages/campus-recruiting', [
      'getOrientationsDetailsById',
      'getRecruitmentDetailsById'
    ]),
    ...mapActions('pages/enterprises', [
      'getEnterpriseByToken'
    ]),
    resetTimeSlots () {
      this.batchDelete = this.tempSlots.map(slot => slot.orientation_time_slot_id)
      this.batchDeleteSlots()
    },
    setTempSlots (dates) {
      const yourBookedSlots = dates.map((date, index) => date.orientation_time_slots.filter(
        slot =>
          slot.enterprise_gui_number === this.currentEnterpriseGetter.enterprise_gui_number
      )).flat()

      this.tempSlots = yourBookedSlots.slice()
    },
    removeDoubleBookedTempSlots (dateSlots, dateIndex) {
      const dateIds = dateSlots.filter(slot => slot.has_booked).map(slot => slot.orientation_time_slot_id)
      const tempIds = this.tempSlots.map(slot => slot.orientation_time_slot_id)
      const tempGuiIds = this.tempSlots.map(slot => slot.enterprise_gui_number)
      const notDuplicatedIds = tempIds.filter(selectedId => !dateIds.includes(selectedId))
      const duplicatedIds = tempIds.filter(selectedId => dateIds.includes(selectedId))

      tempIds.forEach((tempId, tempIndex) => {
        if (notDuplicatedIds.length > 0 && notDuplicatedIds.includes(tempId)) {
          this.updateSelectSlot(this.tempSlots[tempIndex], true)
        }
      })
      tempIds.forEach((tempId, tempIndex) => {
        if (
          duplicatedIds.length > 0 &&
          duplicatedIds.includes(tempId) &&
          tempGuiIds[tempIndex] !== this.currentEnterpriseGetter.enterprise_gui_number
        ) {
          this.tempSlots.splice(tempIndex, 1)
        }
      })
    },
    addSlot (slot) {
      this.tempSlots.push(slot)
      this.updateSelectSlot(slot, true)
    },
    updateSelectSlot (newSlot, toNew) {
      const slot = {
        orientation_time_slot_id: newSlot.orientation_time_slot_id,
        orientation_date: newSlot.orientation_date,
        orientation_start_time: newSlot.orientation_start_time,
        orientation_end_time: newSlot.orientation_end_time,
        has_booked: toNew,
        enterprise_gui_number: toNew ? this.currentEnterpriseGetter.enterprise_gui_number : '',
        enterprise_name: toNew ? this.currentEnterpriseGetter.enterprise_name : ''
      }

      const dateIndex = this.currentSlots.findIndex(currentDate => currentDate.orientation_date === slot.orientation_date)
      const slotIndex = this.currentSlots[dateIndex].orientation_time_slots.findIndex(currentSlot => currentSlot.orientation_time_slot_id === slot.orientation_time_slot_id)

      this.currentSlots[dateIndex].orientation_time_slots.splice(slotIndex, 1, slot)
    },
    batchDeleteSlots () {
      this.batchDelete.forEach(slot => {
        const tempIndex = this.tempSlots.findIndex(temp => temp.orientation_time_slot_id === slot)
        this.tempSlots.splice(tempIndex, 1)

        this.currentSlots.forEach((date, dateIndex) => {
          const slotIndex = date.orientation_time_slots.findIndex(currentSlot => currentSlot.orientation_time_slot_id === slot)
          if (slotIndex > -1) {
            this.updateSelectSlot(this.currentSlots[dateIndex].orientation_time_slots[slotIndex], false)
          }
        })
        this.batchDelete = []
      })
    }
  }
}
</script>
